defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClubCoupons/FinishedTab',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent'
  ],
  function (m, NumberGamesUtils, Loader, CtaButton, CardContent) {
    const FinishedTab = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.couponsCount = () => this.finishedCoupons().length;
        this.listLimit = m.prop(true);
      },

      view: function (controller, ignoreArgs, $slots) {
        const content = () => {
          if (controller.loading()) {
            return Loader(controller);
          }

          if (controller.couponsCount() === 0) {
            return controller.$noCoupons({
              title: controller.clubCouponsDictionary('FinishedTab/NoCouponsTitle'),
              description: controller.clubCouponsDictionary('FinishedTab/NoCouponsDescription')
            });
          }

          const coupons = controller.finishedCoupons();

          return [
            m('.play-together-club-coupon__items-list', coupons.map((coupon) => {
              const fundingDate = NumberGamesUtils.formatISO8601(coupon.fundingDate, { includeTime: false }).toUpperCase();
              const drawDate = NumberGamesUtils.formatISO8601(coupon.drawDate, { includeTime: false }).toUpperCase();
              const drawDetails = [
                m('.play-together-club-coupon-item__funding-date', fundingDate),
                m('.play-together-club-coupon-item__draw-date', controller.clubCouponsDictionary('FinishedTab/DrawDetail', { drawDate }))
              ];

              return controller.$couponItem({ coupon, drawDetails });
            })),
          ];
        };

        return CardContent({
          $header: $slots.header,
          $content: content(),
          $footer: $slots.footer
        });
      }
    };

    return FinishedTab;
  });
